<template>
  <partner-refer-alert v-if="visible" />
</template>

<script>
import PartnerReferAlert from '@/views/config/partner-refer/component/alert-message';
import { mapActions, mapGetters } from 'vuex';
import _, { debounce, isEqual } from 'lodash';
import { getMessageStringByRules, popUpDialogForAfterValidate } from '@/views/config/partner-refer/helper/validator';
import { getPartnerRefer } from '@/views/config/partner-refer/helper/utils';
import { isEmptyVal } from '@/utils';
import InitModalConfigDialog from '@/views/config/partner-refer/plans/init-modal-config.vue';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import { OPC_CONSTANT_PATH } from '@/common/constants';
import eventListenerMixin from '@/views/config/partner-refer/mixin/event-listener';

// in order to fix config/checkout page both new this component, auto call validate function
let partnerReferHaveRegister = false;

// when the partner init at first, should sign the status
let globalInitFeatureRegister = false;

export default {
  components: { PartnerReferAlert },
  mixins: [eventListenerMixin],
  created() {
    this.initModalConfigDialog = new ServiceConfirm(InitModalConfigDialog);
  },
  computed: {
    ...mapGetters(['referralCouponStatus', 'lastShowInEligibleMsg', 'promoExternalProduct', 'getSelectedPlansWithQuantityMap', 'soldToContact', 'partnerMessageLoading', 'showInEligibleMsg', 'ignoreCheckPartner', 'partnerRefer', 'partnerFeaturesDependOnRules']),
    visible() {
      // [partner hard code]
      // Whether the banner mode needs to be displayed
      // [partner A/B/C] test use planCard mode, will show ineligible banner message in checkout page
      if (this.partnerFeaturesDependOnRules?.usePlanCardMode) {
        return this.showInEligibleMsg || (this.lastShowInEligibleMsg && this.partnerMessageLoading);
      }

      return !this.promoExternalProduct;
    },
    initOfferFeatureDetailContent() {
      return getMessageStringByRules(this.partnerRefer.initOfferFeatureDetailContent);
    },
  },
  data() {
    return {
      blockModalOfferDetailVisible: false,
    };
  },
  methods: {
    ...mapActions(['preCheckPartnerByReferralCoupon']),
    /**
     * use coupon service to check partner referral (fake coupon, just validate, not redeem)
     */
    debouncePreCheckPartnerByReferralCoupon: debounce(function() {
      this.preCheckPartnerByReferralCoupon();
    }, 500),
    callAutoVerifyFunction() {
      this.debouncePreCheckPartnerByReferralCoupon();
    },
    popUpIneligibleDialog(invalid) {
      const partnerRefer = getPartnerRefer();

      if (isEmptyVal(partnerRefer)) return;
      if (this.ignoreCheckPartner) return;

      /**
       * blockModalOfferDetailVisible in order to avoid show repeat dialog
       */
      if (
        partnerRefer.rules?.afterBlockOfferModalSwitch
        && !this.partnerMessageLoading
        && invalid
        && !this.blockModalOfferDetailVisible
        && !this.lastShowInEligibleMsg
        // record last whether to show msg (in order to fix call backend api), avoid repeat show dialog (when the last check is invalid, current is also invalid, we do not show dialog)
        // when the api pending, origin check result is false, pending -> will lead check status (false -> true), will call watch showInEligibleMsg function
        // when the api is resolved, check result will switch (true -> false), will call watch showInEligibleMsg function
      ) {
        this.blockModalOfferDetailVisible = true;

        popUpDialogForAfterValidate()
          .then(() => {
            if (this.partnerRefer?.features?.afterBlockOfferModalConfirmAction === "redirect") {
              window.location.href = OPC_CONSTANT_PATH.basic2pro;
            }
          })
          .finally(() => {
            this.blockModalOfferDetailVisible = false;
          });
      }
    },
    showInitModalConfigDialog() {
      if (globalInitFeatureRegister) return;

      if (!isEmptyVal(this.initOfferFeatureDetailContent) ) {
        globalInitFeatureRegister = true;
        return this.initModalConfigDialog.confirm();
      }
    },
  },
  watch: {
    getSelectedPlansWithQuantityMap: {
      immediate: true,
      handler(newVal, oldVal) {
        // in order to fix config page/checkout page both to new this component, will repeat call this watch function
        // when the oldVal is undefined and this comp have register,
        // will not call validate function, only first new comp will call validate function
        if (_.isUndefined(oldVal) && partnerReferHaveRegister) {
          return;
        }

        if (_.isUndefined(oldVal)) {
          partnerReferHaveRegister = true;
        }

        // As long as the shopping cart changes, need call api is required
        // add/remove product or increase/decrease plan's license
        const isNeedCall = isEqual(newVal, oldVal) === false;

        // if the shopping cart can not change, so don't need call any api with partner check
        if (!isNeedCall) return;

        this.callAutoVerifyFunction();
      },
    },
    'soldToContact.country': {
      handler() {
        this.callAutoVerifyFunction();
      },
    },
    'showInEligibleMsg': {
      handler(val) {
        this.popUpIneligibleDialog(val);
      },
    },
  },
  mounted() {
    this.showInitModalConfigDialog();
  },
};
</script>
